module.exports = {
	name: 'IdleDetector',
	provides: 'idleDetector',
	main: 'idle_detector.js',
	dependencies: {
		/** @type Logger */
		logger: true,

		/** @type jQuery */
		jQuery: true,

		/** @type Document */
		document: true
	},
	init: 'init'
};
